import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0bdefd1d")

_pushScopeId("data-v-0bdefd1d")
const _hoisted_1 = {
  key: 0,
  class: "layout-item"
}
const _hoisted_2 = { class: "radio-btn" }
const _hoisted_3 = { class: "layout-description" }
const _hoisted_4 = { class: "layout-screen" }
const _hoisted_5 = {
  key: 1,
  class: "layout-item-mobile"
}
const _hoisted_6 = { class: "layout-screen" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "radio-btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (!_ctx.isMobileScreen)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_RadioButton, {
            label: _ctx.name,
            size: "m",
            value: _ctx.type,
            name: "layout",
            modelValue: _ctx.active,
            "onUpdate:modelValue": _ctx.onRadioSelect
          }, null, 8, ["label", "value", "modelValue", "onUpdate:modelValue"])
        ]),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {src: _ctx.layoutScreen}, null, 16)
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("img", {src: _ctx.layoutScreen}, null, 16)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.name), 1),
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.description), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_RadioButton, {
            value: _ctx.type,
            size: "l",
            name: "layout",
            modelValue: _ctx.active,
            "onUpdate:modelValue": _ctx.onRadioSelect
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue"])
        ])
      ]))
})